import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://dev.myjoygames.com',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default instance;
